/**
 * Identidad del comercio, en un solo lugar.
 *
 * El proyecto nacio como un e-commerce de alimentos ultracongelados y se
 * reutiliza como prototipo de bazar. Centralizar la marca y el rubro evita
 * volver a tener el nombre disperso en 15 archivos.
 */
export const BRAND = {
    /** Nombre corto, para navbar, titulos y botones. */
    name: 'Ardel',
    /** Nombre completo, para documentos y datos estructurados. */
    legalName: 'Ardel',
    /** Version en mayusculas para los PDF. */
    upper: 'ARDEL',
    tagline: 'Bazar y articulos para el hogar',
    description:
        'Bazar con todo para tu casa: cocina, mesa, organizacion, bano y deco.',
} as const;

/**
 * Rubro del catalogo.
 *
 * Los campos de producto especificos de alimentos (ultracongelado, envasado
 * al vacio, sugerencias de coccion, ingredientes, vencimiento) siguen
 * existiendo en la base, pero solo se muestran cuando el rubro es 'alimentos'.
 * Asi el mismo codigo sirve para los dos casos sin borrar funcionalidad.
 */
export type Rubro = 'bazar' | 'alimentos';

export const RUBRO = 'bazar' as Rubro;

/**
 * true cuando los campos propios de alimentos deben mostrarse.
 * Cambiar RUBRO a 'alimentos' los reactiva sin tocar los componentes.
 */
export const MOSTRAR_CAMPOS_ALIMENTOS: boolean = RUBRO === 'alimentos';

/** Etiquetas que cambian segun el rubro. */
export const LABELS = {
    /** Bloque descriptivo principal en la ficha de producto. */
    detalleProducto: MOSTRAR_CAMPOS_ALIMENTOS ? 'Ingredientes' : 'Caracteristicas',
    /** Segundo bloque descriptivo. */
    detalleSecundario: MOSTRAR_CAMPOS_ALIMENTOS ? 'Sugerencias de coccion' : 'Uso y cuidado',
} as const;
